import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditCreateService } from 'tms-web-shared';
import { MachineHours } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class MachineHoursService extends TmsWebBaseEditCreateService<MachineHours, MachineHours> {
  constructor() {
    super('MachineHours', $localize`Machine Hours`);
  }

  getForMachine(machineId: string): Observable<MachineHours[]> {
    return this.httpService.get<MachineHours[]>(`${this.apiUrl}/Machine/${machineId}`);
  }
}
